<template>
  <div></div>
</template>

<script>
  import { SetGetAuthInfo } from '@/util/auth'
  import { getThirdUserInfo } from '@/api/user'


  export default {
    name: 'index',
    components: {},
    mixins: [],
    props: {},

    data() {
      return {}
    },

    computed: {},

    watch: {},

    created() {},

    async mounted() {
      const query = this.$route.query
      const queryUserInfo = {
        openId: query.openId,
        headImg: decodeURIComponent(query.headImg),
        nickName: decodeURIComponent(query.nickName),
        isSubscribe: query.isSubscribe + ''
      }
      SetGetAuthInfo.setInfo(queryUserInfo)
      this.$store.commit('SET_USER_INFO', queryUserInfo)
      try {
        if (query.uptt) {
          await this.$store.dispatch('getUserToken', { wx_ticket: query.uptt })
          // 神策埋点
          if(SetGetAuthInfo.getInfo().mobilePhone){
            let res = await getThirdUserInfo({
              mobilePhone: SetGetAuthInfo.getInfo().mobilePhone
            })
            this.$sensors.login({
              platformCode: this.$store.state.deviceInfo.env,
              appCode: process.env.VUE_APP_BAOSICODE,
              deviceId: localStorage.getItem('anonymous_id'),
              distinctId: localStorage.getItem('distinct_id'),
              userId: res
            })        
          }
        }
        if (query.fromPath) {
          this.$router.replace({ path: decodeURIComponent(query.fromPath) })
        } else {
          this.$router.replace({ path: '/404' })
        }
      } catch (e) {
        console.log(e)
        this.$notify({ type: 'danger', message: e.message })
      }
    },

    destroyed() {},

    methods: {}
  }
</script>

<style scoped></style>
